<template>
  <div>

    <pageTable ref="snTable"
               :tableTitle="tableColumn"
               :searchData="searchData"
               tableApi="admin/gas/stockLog"
    >
      <template v-slot:searchFormItem>
        <FormItem prop="ctime">
          <DatePicker v-model="searchData.ctime" type="datetimerange" @on-change="timeChange" placeholder="时间" style="width: 320px"></DatePicker>
        </FormItem>
      </template>

      <template v-slot:otherBtn>
        <Button type="info" @click="download">导出</Button>
      </template>

    </pageTable>

  </div>
</template>

<script>
  import pageTable from "@/components/table/pageTable";
  import XLSX from 'xlsx'

  export default {
    name: "stockLog",
    components:{pageTable},
    props:{
      stationId:{
        type:Number,
        default: 0
      }
    },
    data() {
      return {
        searchData: {
          stationID:this.stationId,
          ctime:''
        },
        tableColumn: [
          {title: 'ID',key: 'id',align: "center"},
          {title: '发生数量',key: 'litre_num',align: "center"},
          {title: '消费前数量',key: 'before_litre_num',align: "center"},
          {title: '消费后数量',key: 'after_litre_num',align: "center"},
          {title: '时间',key: 'ctime',align: "center"},
          {title: '类型',key: 'type_name',align: "center"},
          {title: '备注',key: 'remark',align: "center"},
        ],
        tableData: [],

      }
    },
    methods: {
      download(){
        this.$commonFun.postProxy('admin/gas/exportStockLog',this.searchData).then(res=>{
          this.$commonFun.dealApiResult(res,()=>{
            let worksheet = XLSX.utils.aoa_to_sheet(res.data)
            let workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(workbook,worksheet,'sheet1')
            XLSX.writeFile(workbook,`站点库存记录.xlsx`)
          })
        })
      },
         timeChange(time) {
        if(time[1].slice(-8)==='00:00:00'){
          time[1] = time[1].slice(0,-8) + '23:59:59'
          this.searchData.ctime = time
        }
      },
    },
    mounted() {
    },
  }
</script>

<style scoped>

</style>
